/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_No_InvoicesInputs */



/**
* | output |
* | --- |
* | "No invoices yet. Your first invoice will appear after the current billing period." |
*
* @param {Billing_No_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_no_invoices = /** @type {((inputs?: Billing_No_InvoicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_No_InvoicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Rechnungen. Ihre erste Rechnung erscheint nach dem aktuellen Abrechnungszeitraum.")
	return /** @type {LocalizedString} */ ("No invoices yet. Your first invoice will appear after the current billing period.")
});